module.exports = __webpack_public_path__ + "img/know your composition.9f064fe5.jpg";